import React, { useState } from "react";
import { CheckCircle2Icon } from "lucide-react";
import { Field } from "../forms/Field";
import { inputClass, isEmail } from "../../utils/formStyles";
import { contactSubjects } from "../../data/pages";
type Errors = Partial<Record<"name" | "email" | "message", string>>;
export function ContactForm() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    subject: contactSubjects[0],
    message: ""
  });
  const [errors, setErrors] = useState<Errors>({});
  const [status, setStatus] = useState<"idle" | "sending" | "success">("idle");
  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    const next: Errors = {};
    if (!form.name.trim()) next.name = "Indiquez votre nom.";
    if (!isEmail(form.email)) next.email = "Adresse e-mail invalide.";
    if (form.message.trim().length < 10) next.message = "Votre message est trop court.";
    setErrors(next);
    if (Object.keys(next).length) return;
    setStatus("sending");
    window.setTimeout(() => setStatus("success"), 900);
  };
  if (status === "success") {
    return <div className="rounded-[28px] bg-sand p-8 md:p-10" role="status" data-id="element-16" data-mp="k2afzlggolwx">
        <CheckCircle2Icon className="h-10 w-10 text-red" data-id="element-17" data-mp="k0zcznuubi6v" />
        <h2 className="mt-4 font-serif text-3xl" data-id="element-18" data-mp="f2fr1ng8y6ei">Message envoyé</h2>
        <p className="mt-2 text-navy-soft" data-id="element-19" data-mp="b1m2qsyw6pl3">Merci, nous vous répondrons sous quelques jours.</p>
        <button type="button" onClick={() => {
        setForm({
          name: "",
          email: "",
          subject: contactSubjects[0],
          message: ""
        });
        setStatus("idle");
      }} className="mt-6 font-semibold underline underline-offset-4" data-id="element-20" data-mp="17rwd83d9wr2a">
          Envoyer un autre message
        </button>
      </div>;
  }
  return <form onSubmit={submit} noValidate className="space-y-5 rounded-[28px] bg-sand p-6 md:p-10" data-id="element-21" data-mp="yt16mq6bheyg">
      <div className="grid gap-5 md:grid-cols-2" data-id="element-22" data-mp="tug5moj8qr8y">
        <Field id="c-name" label="Nom" error={errors.name} data-id="element-23" data-mp="3jigsd6qoidh8">
          <input id="c-name" className={inputClass} value={form.name} onChange={e => setForm({
          ...form,
          name: e.target.value
        })} aria-invalid={!!errors.name} aria-describedby={errors.name ? "c-name-error" : undefined} data-id="element-24" data-mp="3eicd1k1ibosl" />
        </Field>
        <Field id="c-email" label="E-mail" error={errors.email} data-id="element-25" data-mp="3kxji63x3ukw8">
          <input id="c-email" type="email" className={inputClass} value={form.email} onChange={e => setForm({
          ...form,
          email: e.target.value
        })} aria-invalid={!!errors.email} aria-describedby={errors.email ? "c-email-error" : undefined} data-id="element-26" data-mp="36z3dsjmpt6h9" />
        </Field>
      </div>
      <Field id="c-subject" label="Sujet" data-id="element-27" data-mp="2x7p4jk4yosax">
        <select id="c-subject" className={inputClass} value={form.subject} onChange={e => setForm({
        ...form,
        subject: e.target.value
      })} data-id="element-28" data-mp="3208l8pyy43jy">
          {contactSubjects.map(s => <option key={s} data-id="element-29" data-mp="2n8zmnrd2f7uo">{s}</option>)}
        </select>
      </Field>
      <Field id="c-message" label="Message" error={errors.message} data-id="element-30" data-mp="2sagmdjjtco9o">
        <textarea id="c-message" rows={6} className={inputClass} value={form.message} onChange={e => setForm({
        ...form,
        message: e.target.value
      })} aria-invalid={!!errors.message} aria-describedby={errors.message ? "c-message-error" : undefined} data-id="element-31" data-mp="2e9w2sl62qof4" />
      </Field>
      <button type="submit" disabled={status === "sending"} className="rounded-full bg-red px-8 py-4 font-semibold text-white transition-colors duration-150 hover:bg-red-deep disabled:opacity-60" data-id="element-32" data-mp="1zpa4lzifdqsr">
        {status === "sending" ? "Envoi en cours…" : "Envoyer le message"}
      </button>
    </form>;
}